export const addToActivityQueueQueryFn = (
  member_id: string,
  activity_datetime_start: string,
  datetime_to_place_in_queue: string,
  activity_id: string
) => {
  const query = `
        AddToQueueActivity(
            member_id: $member_id,
            activity_datetime_start: $activity_datetime_start,
            datetime_to_place_in_queue: $datetime_to_place_in_queue,
            activity_id: $activity_id
        ) {
            ... on User {
                member_id
                first_name
                last_name
                member_type
            }
            ... on Error {
                message
                code
            }
        }
    `;
  const inputs = `$member_id: String!, $activity_datetime_start: String!, $datetime_to_place_in_queue: String!, $activity_id: String!`;
  const variables = {
    member_id,
    activity_datetime_start,
    datetime_to_place_in_queue,
    activity_id,
  };
  return {
    query,
    inputs,
    variables,
  };
};

export const getActiveActivityQueueSpotsByMemberQueryFn = (
  member_id: string
) => {
  const query = `
        getActiveActivityQueueSpotsByMember(member_id: $member_id) {
            ... on ActivityQueueItem {
                PK
                datetime_start
                first_name
                phone_number
                placed_in_queue
                activity_id
            }
            ... on Error {
                message
                code
            }   
        }
    `;
  const inputs = `$member_id: String!`;
  const variables = { member_id };
  return {
    query,
    inputs,
    variables,
  };
};
